import React from 'react';
import { Box, Skeleton } from '@mui/material';

const MustSeeSpotsSkeleton = () => (
  <Box className="must-see-spots-grid">
    {Array.from({ length: 6 }).map((_, index) => (
      <Box
        className="spot-card"
        key={index}
        sx={{
          cursor: 'pointer',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)'
          }
        }}>
        <Skeleton variant="rectangular" width="100%" height={180} className="spot-image" />
        <Skeleton variant="text" width="60%" height={24} className="spot-explore" />
        <Skeleton variant="text" width="80%" height={24} className="spot-name" />
      </Box>
    ))}
  </Box>
);

export default MustSeeSpotsSkeleton;
